import React from "react";
import { FourYearFeedInner, FourYearSkeletonCard } from "./FourYear.styles";

const FourYearFeedSkeleton = () => (
  <FourYearFeedInner aria-hidden="true">
    <FourYearSkeletonCard />
    <FourYearSkeletonCard />
  </FourYearFeedInner>
);

export default FourYearFeedSkeleton;
